import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Table from "components/Table";
import FieldChooser from "components/FieldChooser";
import TopButtons from "components/TopButtons";
import { IInspectionReport, IMeta, ICommonState } from "models/.";
import { connect } from "../../reduxConnector";
import { columns } from "./columns";
import InspectionReportActions from "./actions";
import InspectionReportSearch from "./partials/InspectionReportSearch";
import { markAsRead, markAsUnread } from "../app/actions";
import { downloadDocuments } from "helpers/download";
import { getSelectedData } from "helpers/common";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps {
  getInspectionReports: (meta?: IMeta) => void;
  reports: IInspectionReport[];
  meta: IMeta;
  typeOptions: any[];
  getSelectOptions: () => void;
}

interface IState extends ICommonState {
  selectedData: any;
}

class InspectionReport extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: "",
      showFieldChooser: false,
      columnsCopy: [],
      checkedRows: {},
      selectedData: []
    };
  }

  public componentDidMount() {
    const { typeOptions, getSelectOptions } = this.props;
    if (!typeOptions || !typeOptions.length) {
      getSelectOptions();
    }
  }

  public handleSelect = selectedOption => {
    const { checkedRows, selectedData } = this.state;
    const { value } = selectedOption;
    const ids = _(checkedRows)
      .keys()
      .map(_.toNumber)
      .value();

    value === "gelezen" && markAsRead(ids, "Receipt");
    value === "ongelezen" && markAsUnread(ids, "Receipt");
    if (value === "pdf") {
      const documentIds = _.compact(_.map(selectedData, "documentId"));
      downloadDocuments(documentIds, "RECEIPTS_REPORT");
      markAsRead(ids, "Receipt");
    }
  };

  public handleFieldChooser = () => {
    this.setState(({ showFieldChooser }) => ({
      showFieldChooser: !showFieldChooser
    }));
  };

  public handleFieldsChange = data => {
    this.setState({ columnsCopy: data });
  };

  private onRowSelect = checkedRows => {
    this.setState({
      checkedRows,
      selectedData: getSelectedData(
        this.props.reports,
        checkedRows,
        this.state.selectedData
      )
    });
  };

  public render() {
    const { getInspectionReports, reports, meta, typeOptions } = this.props;

    const {
      showFieldChooser,
      columnsCopy,
      selectedOption,
      checkedRows
    } = this.state;

    return (
      <div id="inspection-reports-page">
        <FormattedMessage id="RECEIPTS_REPORT" tagName="h1" />
        <InspectionReportSearch
          meta={meta}
          onSearch={getInspectionReports}
          typeOptions={typeOptions}
        />
        <TopButtons
          switchUnread={meta.unread}
          handleFieldChooser={this.handleFieldChooser}
          handleSelect={this.handleSelect}
          toggleUnread={() =>
            getInspectionReports({
              ...meta,
              unread: !meta.unread,
              currentPage: 0
            })
          }
          selectedOption={selectedOption}
          entityName="inspection"
        />
        <Table
          columns={columnsCopy}
          dataSource={reports}
          meta={meta}
          onQueryChange={getInspectionReports}
          onRowSelect={this.onRowSelect}
          checkedRows={checkedRows}
          pageName={CUSTOM_SETTINGS.inspectionReport}
        />
        <FieldChooser
          name="kpb_ontvangstrapport"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={columns}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    reports: state.inspectionReports.items,
    meta: state.inspectionReports.meta,
    typeOptions: state.inspectionReports.typeOptions
  }),
  {
    getInspectionReports: InspectionReportActions.getInspectionReports,
    getSelectOptions: InspectionReportActions.getSelectOptions
  }
)(InspectionReport);
